// test1385
(1385 && 0);
